



















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Button extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly disabled!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly link!: boolean;

  @Prop({ type: Object, default: () => ({}) })
  readonly to!: any;

  clickHandler() {
    if (!this.disabled) this.$emit('click');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/info/components/button/Button.vue